module.exports = __webpack_public_path__ + "static/media/laatulakki_long_logo_2024.0f23721d.png";